<template>
  <div>
    <a-spin :spinning="spinning" class="w-100">
      <detail
        v-if="$root.$checkAuth($auth[authName] && $auth[authName].receiptList)"
        :list="list"
        :user_id="user_id"
        :is-look="handle === $var.Handle.look"
        :auth-name="authName"
        @onEdit="onEditHandle"
        @success="onSuccess"
      ></detail>
    </a-spin>

    <div
      v-if="handle !== $var.Handle.look && $root.$checkAuth($auth[authName] && $auth[authName].addReceipt) "
      class="text-center"
    >
      <a-button type="dashed" size="large" class="w-100" @click="onHandle($var.Handle.add)">
        <a-icon type="plus" />添加收款信息
      </a-button>
    </div>

    <dialog-add
      :user_id="user_id"
      :default-value="dialogFormDefault"
      :visible.sync="showHandleDialog"
      :handle="handleType"
      @success="onSuccess"
    ></dialog-add>
  </div>
</template>

<script>
  import detail from "./components/detail";
  import DialogAdd from './components/DialogAdd.vue'

  export default {
    data() {
      return {
        title: "收款信息",

        showHandleDialog: false,
        dialogFormDefault: {},
        handleType: 'add',

        list: [],

        spinning: false,
      };
    },

    props: {
      user_id: String,
      handle: String,
      authName: String
    },

    components: {
      detail,
      DialogAdd,
    },

    created() {
      this.getData();
    },

    methods: {
      onSuccess() {
        this.getData();
      },

      onEditHandle(item) {
        item = Object.assign({}, item, {
          is_default: !!+item.is_default
        })

        this.dialogFormDefault = item;

        this.onHandle(this.$var.Handle.edit);
      },

      getData() {
        let param = {user_id: this.user_id};

        this.spinning = true;

        this.$axios.Sup_Cash_list(param).then(res => {
          const data = res.data;

          if (data && data.code == 0) {
            // something
            this.list = data.data.list;
          }

          this.spinning = false;
        })
      },

      onHandle(type) {
        if(type === this.$var.Handle.add){
          this.dialogFormDefault = {};
        }

        this.handleType = type;
        this.showHandleDialog = true;
      },
    }
  };
</script>

<style lang="scss" scoped>
  .add-btn {
    cursor: pointer;

    .iconfont {
      width: 20px;
      height: 20px;
      margin-right: 2px;
    }
  }
</style>
